<template>
    <div class="dropdown">
        <button class="dropdown-toggle" @click="toggleDropdown">
            {{ selectedOption ? selectedOption.label : placeholder }}
            <span class="arrow">
                <svg width="13" height="24" viewBox="0 0 13 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.5 7.5L6.5 4.5L3.5 7.5" stroke="#D9D9D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M9.5 16.5L6.5 19.5L3.5 16.5" stroke="#D9D9D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </span>
        </button>
        <ul v-if="isOpen" class="dropdown-menu">
            <li
                v-for="(option, index) in options"
                :key="index"
                @click="selectOption(option)"
                :class="{ selected: selectedOption && option.value === selectedOption.value }"
            >
                {{ option.label }}
                <span v-if="selectedOption && option.value === selectedOption.value" class="checkmark">
                    <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.39062 14.3828C5.97396 14.3828 5.61979 14.2031 5.32812 13.8438L1.28125 8.85938C1.16667 8.72396 1.08333 8.59115 1.03125 8.46094C0.984375 8.33073 0.960938 8.19531 0.960938 8.05469C0.960938 7.74219 1.0651 7.48438 1.27344 7.28125C1.48177 7.07812 1.74479 6.97656 2.0625 6.97656C2.42188 6.97656 2.72396 7.13021 2.96875 7.4375L6.35938 11.7344L12.9766 1.25C13.112 1.04167 13.2526 0.895833 13.3984 0.8125C13.5443 0.723958 13.7266 0.679688 13.9453 0.679688C14.263 0.679688 14.5234 0.778646 14.7266 0.976562C14.9297 1.17448 15.0312 1.42708 15.0312 1.73438C15.0312 1.85938 15.0104 1.98438 14.9688 2.10938C14.9271 2.23438 14.862 2.36458 14.7734 2.5L7.46094 13.8125C7.21094 14.1927 6.85417 14.3828 6.39062 14.3828Z" fill="#646464"/>
                    </svg>
                </span>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'CustomDropdown',
    props: {
        value: {
            type: [String, Number], // Поддерживает строки или числа
            default: ''
        },
        options: {
            type: Array,
            required: true, // Массив объектов { label, value }
            validator: (options) => options.every(opt => 'label' in opt && 'value' in opt)
        },
        placeholder: {
            type: String,
            default: 'Выберите опцию'
        }
    },
    data() {
        return {
            isOpen: false,
            selectedOption: this.findOptionByValue(this.value)
        };
    },
    watch: {
        value(newValue) {
            this.selectedOption = this.findOptionByValue(newValue);
        }
    },
    methods: {
        toggleDropdown() {
            this.isOpen = !this.isOpen;
        },
        selectOption(option) {
            this.selectedOption = option;
            this.$emit('input', option.value); // Эмитим только числовое значение
            this.isOpen = false;
        },
        findOptionByValue(value) {
            return this.options.find(opt => opt.value === value) || null;
        }
    }
};
</script>

<style scoped>
.dropdown {
    position: relative;
    display: inline-block;
}

.dropdown-toggle {
    padding: 8px 12px;
    background: transparent;
    border: 1px solid #d9d9d9;
    border-radius: 10px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 40px;
    font-size: 16px;
    color: #000;
}

.arrow {
    margin-left: 8px;
    display: flex;
    align-items: center;
}

.dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0px 7px 29px rgba(100, 100, 111, 0.2);
    list-style: none;
    padding: 0;
    margin: 0;
    z-index: 1000;
}

.dropdown-menu li {
    padding: 8px 16px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #000;
    font-size: 16px;
    height: 40px;
    &:first-child {
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
    }
    &:last-child {
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
    }
}

.dropdown-menu li:hover {
    background-color: #f5eee8;
}

.dropdown-menu li.selected {
    background-color: #f5eee8;
}

.checkmark {
    color: #646464;
}
</style>